<template>
  <v-dialog v-model="dialog" width="90%">

    <v-card elevation="3">
      <div class="pp-sidenav">
        <div class="white--text text-h6 pt-2 pl-5">
          Edit a Vimeo/Youtube
        </div>

        <v-card-subtitle class="white--text">
          Amend details below
        </v-card-subtitle>
      </div>

      <v-img
          src="/images/pp-logo.png"
          height="40"
          contain
          class="logo-course"
      >
      </v-img>

      <v-tabs
          dark
          width="250"
          color="primary"
          vertical
      >
        <v-tab class="pp-sidenav-2">
          <v-icon left>
            mdi-pencil
          </v-icon>
          Edit a Vimeo / Youtube
        </v-tab>

        <v-tab-item>
          <v-card flat v-if="currentVideoItem">
            <v-container>
              <template>
                <v-card
                    color="grey lighten-4"
                    width="100%" flat
                >
                  <v-card-title class="text-h6 grey lighten-3">
                    Edit <span class="primary--text ml-2"> {{ currentVideoItem.title }} </span>
                    <v-icon class="ml-1">mdi-chevron-right</v-icon>
                  </v-card-title>

                  <v-card-text>
                    <div class="py-10 px-2">
                      <v-row>
                        <v-text-field
                            v-model="editableVideoItem.title"
                            label="Edit Vimeo/Youtube Title"
                            aria-required="true"
                            color="primary"
                            placeholder="Edit Vimeo/Youtube Title"
                            prepend-icon="mdi-file-edit-outline"
                            flat
                            solo
                            clearable
                        ></v-text-field>
                      </v-row>

                      <v-row v-if="videoApiError && videoApiError.fields && videoAddError.fields.title" class="err-text">
                        <p class="error--text">
                          Vimeo/Youtube title should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <v-row>
                        <v-text-field
                            v-model="editableVideoItem.uri"
                            aria-required="true"
                            color="primary"
                            label="Vimeo/Youtube URL"
                            placeholder="Add a Vimeo/Youtube URL"
                            prepend-icon="mdi-file-edit-outline"
                            flat
                            solo
                            clearable
                        ></v-text-field>
                      </v-row>

                      <v-row v-if="videoApiError && videoApiError.fields && videoApiError.fields.uri" class="err-text">
                        <p class="error--text">
                          Vimeo/Youtube's URL should not be empty and contain a URL.
                        </p>
                      </v-row>

                      <v-row>
                        <v-select
                            v-model="editableVideoItem.aspectRatio"
                            aria-required="true"
                            :items="aspectRatios"
                            color="primary"
                            label="Aspect Ratio"
                            prepend-icon="mdi-file-edit-outline"
                            flat
                            solo
                            clearable
                        ></v-select>
                      </v-row>

                      <v-row v-if="videoApiError && videoApiError.fields && videoApiError.fields.aspectRatio" class="err-text">
                        <p class="error--text">
                          Please select an aspect ratio for the Vimeo/Youtube.
                        </p>
                      </v-row>

                      <v-row class="mb-5">
                        <v-textarea
                            v-model="editableVideoItem.description"
                            auto-grow
                            hint="The description of the Vimeo/Youtube will be publicly visible"
                            persistent-hint
                            label="Description"
                            aria-required="true"
                            color="primary"
                            placeholder="Edit Vimeo/Youtube Description"
                            prepend-icon="mdi-format-line-style"
                            flat
                            solo
                            clearable
                        ></v-textarea>
                      </v-row>

                      <v-row v-if="videoApiError && videoApiError.fields && videoApiError.fields.description" class="err-text">
                        <p class="error--text">
                          Vimeo/Youtube description should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <ImagePicker v-model="editableVideoItem.image"/>

                      <TagsInput
                          v-model="editableVideoItem.tags"
                          :validationError="videoApiError"
                      />

                      <v-row v-if="videoApiError">
                        <v-alert
                            text
                            color="red"
                            icon="mdi-alert-circle-outline"
                        >
                          There was an error in submission. Please check all fields and try again.
                        </v-alert>
                      </v-row>
                    </div>
                  </v-card-text>
                </v-card>
              </template>
            </v-container>
          </v-card>
          <div v-else>
            <UnavailableContent />
          </div>
        </v-tab-item>
      </v-tabs>

      <!-- ------------------------------------------ buttons ------------------------------------------ -->
      <div class="pp-sidenav">
        <div class="btm">
          <Loading v-if="videoItemLoading"/>
          <ConfirmCancelButtons
              :item="currentVideoItem"
              confirm-text="Save Changes"
              :confirm-disabled="videoItemLoading"
              :confirm-action="editItemConfirm"
              :cancel-action="closeDialog"/>
        </div>
      </div>

      <!-- ------------------------------------------end of buttons ------------------------------------------ -->
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from "@/components/common/Loading";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import { mapActions, mapGetters } from "vuex";
import UnavailableContent from "@/components/common/UnavailableContent";
import ImagePicker from "@/components/common/ImagePicker";
import TagsInput from "@/components/common/TagsInput";

export default {
  name: "VideoEdit",
  components: {TagsInput, UnavailableContent, ImagePicker, Loading, ConfirmCancelButtons},
  computed: {
    ...mapGetters([
      'videoApiError', 'openDialog', 'currentVideoItem', 'editableVideoItem', 'videoItemLoading',
      'aspectRatios',
    ]),
    dialog: {
      get () {
        return this.openDialog === 'videoEdit';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['editVideo', 'clearVideoItems', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.clearVideoItems();
    },
    async editItemConfirm() {
      const edited = await this.editVideo(this.editableVideoItem);

      if (edited) {
        this.closeOpenDialog();
      }
    },
  },
};
</script>
